import TeamFilterDropdown from 'components/dropdowns/TeamFilterDropdown';
import UserEditorTeam from 'components/editors/user-editor/UserEditorTeam';
import InlineMessage from 'components/InlineMessage';
import {
  CollapsedSection,
  FormSection,
  SectionColumn,
  SectionDetails,
  SectionGrid,
  SectionRow,
} from 'components/ui-blocks/form/FormSection';
import React, { PureComponent } from 'react';
import type { Team } from 'types/team';
import type { UsersDraft } from 'types/users';

interface TeamSectionProps {
  draft: UsersDraft;
  teams: Array<Team>;
  selectedTeamIds: Array<number>;
  disabled?: boolean;
  canEditTeams: boolean;
  onChangeSelectedTeams: (ids: Array<number>) => void;
  onRemoveTeam: (teamId: number) => void;
}

class TeamsSection extends PureComponent<TeamSectionProps> {
  renderTeamsList() {
    const { draft, disabled, canEditTeams } = this.props;

    if (!this.props.teams?.length || !draft.teams?.length) {
      if (!this.props.teams?.length) {
        return (
          <InlineMessage type="info" title="No teams created yet">
            <p>You can create and manage teams from the "People" page</p>
          </InlineMessage>
        );
      }
      return (
        <InlineMessage type="info" title="No team assignment">
          <p>Choose teams from the dropdown above.</p>
        </InlineMessage>
      );
    }

    return (
      <div>
        {draft.teams.map(team => (
          <UserEditorTeam
            key={team.id}
            team={team}
            onRemove={this.props.onRemoveTeam}
            disabled={disabled || !canEditTeams}
          />
        ))}
      </div>
    );
  }

  render() {
    let details = (
      <>
        <h3>Teams</h3>
        <p>Add the user to as many teams as you like for easy management.</p>
      </>
    );
    if (!this.props.canEditTeams) {
      details = (
        <>
          <p>All teams the user is part of are listed here. </p>
          <p>
            To add or remove the user from a team, please visit the teams settings page in the
            People section.
          </p>
        </>
      );
    }
    return (
      <FormSection disabled={this.props.disabled}>
        <SectionDetails>{details}</SectionDetails>
        <SectionGrid>
          {!!this.props.teams?.length && this.props.canEditTeams && (
            <SectionRow border="bottom">
              <SectionColumn
                style={{
                  flex: '0 0 auto' /* Make container of dropdown as narrow as possible to position the popover correctly */,
                }}
              >
                <TeamFilterDropdown
                  teams={this.props.teams}
                  selected={this.props.selectedTeamIds}
                  onChange={this.props.onChangeSelectedTeams}
                  highlightModified={false}
                  disabled={this.props.disabled}
                />
              </SectionColumn>
            </SectionRow>
          )}
          <SectionRow direction="column" overflowScroll>
            <SectionColumn size="auto">{this.renderTeamsList()}</SectionColumn>
          </SectionRow>
        </SectionGrid>
      </FormSection>
    );
  }
}

export default TeamsSection;

interface TeamsSectionToggleProps {
  isLockedFeature?: boolean;
  onClick: () => void;
}

export const TeamsSectionToggle: React.FC<TeamsSectionToggleProps> = ({
  onClick,
  isLockedFeature = false,
}: TeamsSectionToggleProps) => {
  return (
    <FormSection
      isEnabled={false}
      isLockedFeature={isLockedFeature}
      enableLabel="+ Assign to team"
      onChange={onClick}
    >
      <CollapsedSection
        title="Teams"
        description="Add the user to as many teams as you like for easy management."
      ></CollapsedSection>
    </FormSection>
  );
};
